<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open': clubOverviewService.listOfModals.editWebhookModal}">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Attributes edit modal title@@clubOverview.workspace.webhookSettings'>Webhook Settings</h3>
    <table class="esf-table">
      <thead class="esf-table__head">
        <tr class="esf-table__row">
          <th class="esf-table__cell esf-table__cell--head"
              i18n-data-label='Table cell heading@@general.tableCellLabel.webhook'
              data-label="Name">
            <span class="esf-table__cell-inner"
                  i18n='Table cell heading@@general.tableCellLabel.webhook'>Webhook</span>
          </th>
          <th class="esf-table__cell esf-table__cell--head"
              i18n-data-label='Table cell heading@@general.tableCellLabel.status'
              data-label="Status">
            <span class="esf-table__cell-inner"
                  i18n='Table cell heading@@general.tableCellLabel.status'>Status</span>
          </th>
        </tr>
      </thead>
      <tbody class="esf-table__body">
        <ng-container *ngFor="let webhook of selectedClub.webhooks; let i = index">
          <tr class="esf-table__row">
            <td class="esf-table__cell"
                data-label="Name">
              <span class="esf-table__cell-inner">{{ webhook.translatedName }}</span>
            </td>

            <td class="esf-table__cell"
                data-label="Status">
              <div class="esf-toggle">
                <input class="esf-toggle__input"
                       type="checkbox"
                       [id]="i"
                       [checked]="webhook.checked"
                       (change)="webhook.checked = !webhook.checked">
                <label class="esf-toggle__label"
                       [for]="i">
                  <div class="esf-toggle__button">
                    <div class="esf-toggle__button-background">
                      <div class="esf-toggle__button-handle"></div>
                    </div>
                  </div>
                </label>
              </div>
            </td>
          </tr>
        </ng-container>

      </tbody>
    </table>
  </div>

</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
    <app-submit-row-buttons [form]="'editClubCommunicationForm'"
                            [cancelButtonText]="buttonsTranslations.i18nBack"
                            [submitButtonText]="buttonsTranslations.i18nSubmit"
                            [spinnerName]="spinnerName"
                            (cancelButton)="clubOverviewService.toggleAllModal(false)"
                            (submitButton)="updateClub()">
    </app-submit-row-buttons>
  </div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition"
     [ngClass]="{'-is-open': clubOverviewService.listOfModals.editWebhookModal }" (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
